import Image from '@components/Image';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import PpCardListContext from './context/PpCardListContext';
import useOnPpCardClick from './hooks/useOnPpCardClick';

function ImageSwiper() {
    const {
        setSwiper, setSliderIndex, data, sliderIndex,
    } = useContext(PpCardListContext);
    const { images } = data;
    const onCardClick = useOnPpCardClick();
    return (
        <Swiper slidesPerView={1}
            loop
            onSwiper={(s) => setSwiper(s)}
            spaceBetween={-120}
            css={css`width: 100%`}
            onSlideChange={(s) => setSliderIndex(s.realIndex)} >
            {images.map((card, i) => (
                <SwiperSlide key={card.id}>
                    <Card onClick={() => onCardClick(card.id)}>
                        <CardImage src={card.imageUrl}
                            isActive={i === sliderIndex}
                            width={256}
                            height={168}
                            alt={card.title}/>
                    </Card>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

const Card = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const CardImage = styled(Image)<{
    isActive: boolean;
}>`
    border-radius: 20px;
    object-fit: cover;
    transform: ${({ isActive }) => (isActive ? 'none' : 'scaleY(.71428) scaleX(.875)')};
    transition: 100ms linear;
`;

export default ImageSwiper;
